module.exports = __webpack_public_path__ + "static/media/add.cbb77f03.svg";